import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Image } from "react-bootstrap";
import { Navigate, Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from 'react-router-dom';
import Modal from "react-bootstrap/Modal";
import ReactPlayer from "react-player";

import udyami_launchpad_logo from "../../../assets/images/udyami-launchpad-logo.png";
import Logo from "../../../assets/images/Samdhan-Logo-New.png";
import { FaUser } from "react-icons/fa6";





export default function Header() {
    const { t } = useTranslation();

    const { AuthReducer: { loading, errors, isAuthenticated } } = useSelector(state => state)
    const router = useNavigate()
    const dispatch = useDispatch()
    const [search, setSearch] = useState("");
    const [searchList, setSearchList] = useState([]);

    // ---------------------------------------------------------
    //             Take a Tour Video Modal Code (START) 
    // ---------------------------------------------------------

    const [show, setShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [videoTitle, setVideoTitle] = useState("");
    const handleShow = (url, title) => {
        setVideoUrl(url);
        setVideoTitle(title);
        setShow(true);
    };
    const handleCloseBtn = () => {
        setShow(false);
        setVideoUrl("");
        setVideoTitle("")
    };

    // ---------------------------------------------------------
    //             Take a Tour Video Modal Code (END) 
    // ---------------------------------------------------------

    return (
        <>
            <header className="header">
                {/* <div className="bg-gradient-style-2 py-2">
                    <div className="container">
                        <div className="social-links">
                            <a
                                href={"https://www.facebook.com/cmyuvaa"}
                                target="_blank"
                                className="social-links-items text-white h6 py-0 my-0"
                            >
                                <FontAwesomeIcon icon={faFacebook} />
                            </a>
                            <a
                                href={"https://www.instagram.com/cm_yuva?igsh=MTN4b2ZoaWF5YXoydg=="}
                                target="_blank"
                                className="social-links-items text-white h6 py-0 my-0"
                            >
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                            <a
                                href={"https://youtube.com/@cmyuva?si=OMaz8zvUUGKoIOWv"}
                                target="_blank"
                                className="social-links-items text-white h6 py-0 my-0"
                            >
                                <FontAwesomeIcon icon={faYoutube} />              </a>
                            <a
                                href={"https://x.com/cm_yuva"}
                                target="_blank"
                                className="social-links-items text-white h6 py-0 my-0"
                            >

                                <FontAwesomeIcon icon={faTwitter} />              </a>
                            <a
                                href={"https://www.linkedin.com/company/cmyuva/"}
                                target="_blank"
                                className="social-links-items text-white h6 py-0 my-0"
                            >
                                <FontAwesomeIcon icon={faLinkedinIn} />
                            </a>
                        </div>
                    </div>
                </div> */}
                <div className="container">

                    {/* <div className="row p-2 d-flex d-sm-none">
                        <div className="col-8 bg-danger d-flex align-items-center justify-content-center " onClick={() => { router("/") }} >
                            <Image
                                src={udyami_launchpad_logo}
                                width="350"
                                height="65"
                                className='img-fluid'
                                alt="image not found"
                                style={{ cursor: 'pointer', }}

                            />
                        </div>
                        <div className="col-4 d-flex align-items-center justify-content-center" onClick={() => { router("/") }} >
                            <Image
                                src={Logo}
                                width="120"
                                height="60"
                                alt="image not found"
                                style={{ marginRight: '12px !important', cursor: 'pointer' }}
                            />
                        </div>

                    </div> */}

                    <div className="header-container justify-content-between">
                        <div className="header-logo col-md-4 col-8" onClick={() => router("/")}>
                            <Image
                                src={udyami_launchpad_logo}
                                width="320"
                                height="65"
                                className='img-fluid'
                                alt="image not found"
                            />

                        </div>
                        <div className='col-md-8 col-3 d-flex align-items-center float-left'>
                            {/* <div className="header-search position-relative d-md-block d-none">
                                <div className="header-search-input w-100">
                                    <FontAwesomeIcon icon={faSearch} className="header-search-input-icon" />
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={search}
                                        onChange={({ currentTarget }) =>
                                            setSearch(currentTarget.value)
                                        }
                                        placeholder="Search Supplier"
                                    />
                                </div>

                                {search.length > 1 && (
                                    <div className="header-search-list">
                                        {searchList.map((item, index) => {
                                            return (
                                                index > 8 && (
                                                    <Link
                                                        key={index}
                                                        href={
                                                            item?.category?.label === "Project Report"
                                                                ? `/project-report/${item.slug}`
                                                                : `/industrial-solution${item?.sub_category &&
                                                                `/industrial-solution/${item?.sub_category?.slug}`
                                                                }/${item?.slug}`
                                                        }
                                                    >
                                                        <div
                                                            className="header-search-list-item"
                                                            key={item.index}
                                                        >
                                                            <h6>{item?.name}</h6>
                                                            <span className="f-small text-accent fw-bold">
                                                                {item?.category?.label}
                                                            </span>
                                                        </div>
                                                    </Link>
                                                )
                                            );
                                        })}
                                    </div>
                                )}
                            </div> */}

                            {/* <Image
                                style={{ marginRight: '12px !important' }}
                                src={Logo}
                                width="120"
                                height="60"
                                alt="image not found"
                                className="d-none d-sm-block"
                            /> */}

                            <div className="header-nav w-100">

                                <a
                                    type="button"
                                    className="round-btn ro-btn-white mx-2 d-md-block d-none"
                                    onClick={() =>
                                        handleShow("https://api.dyntube.com/v1/apps/hls/zqAujAig0qiIaSBFSJVQ.m3u8", "Take a Tour")}
                                >
                                    <span><FaUser /></span>
                                    Take a Tour
                                </a>

                                {!isAuthenticated ? (

                                    // <a href='/login' className="header-nav-link header-outline-btn text-blink">Login</a>
                                    <a type="button" className="smp-round-btn ro-btn-theme" href='/login' >Login</a>

                                )
                                    :
                                    <>
                                        <a href='/' className="header-nav-link header-outline-btn">Dashboard</a>

                                        <a href='/logout' className="header-nav-link header-outline-btn">LogOut</a>
                                    </>
                                }


                            </div>
                        </div>
                    </div>
                </div>
            </header>


            {/* ---------------------------------------------------------
                        Take a Tour (MODAL)
            --------------------------------------------------------- */}

            <Modal
                show={show}
                backdrop="static"
                keyboard={false}
                onHide={handleCloseBtn}
                centered
                className="video-modal"
                animation={false}
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div className="video-frame">
                        <ReactPlayer
                            className="react-player"
                            url={videoUrl || ""}
                            width="100%"
                            height="100%"
                            controls={true}
                            playing={show}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}